function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "logos-_x26_-marks"
}, /*#__PURE__*/React.createElement("g", {
  id: "stackdriver"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(0.000000, 7.530120)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-21",
  fill: "#8CC63F",
  points: "866.693,416.54 234.359,1508.289 866.693,2600.026 2131.363,2600.026  2763.721,1508.289 2131.363,416.54  "
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-22",
  fill: "#009245",
  points: "866.693,2600.05 2122.965,2600.05 1494.46,1508.289  "
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-23",
  fill: "#006837",
  points: "234.212,1508.289 866.707,2600.05 1494.792,1508.289  "
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-24",
  fill: "#39B54A",
  points: "866.606,416.54 234.261,1508.289 1494.398,1508.289 1494.646,1507.774  2122.939,416.54  "
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-25",
  fill: "#8CC63F",
  points: "2127.004,416.54 1498.953,1508.289 2127.004,2600.026 2759.56,1508.289  "
})), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-4",
  x: 234.212,
  y: 234.211,
  fill: "none",
  width: 2531.576,
  height: 2531.578
}))));

function SvgStackdriver(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3000 3000",
    enableBackground: "new 0 0 3000 3000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackdriver);
export default __webpack_public_path__ + "static/media/stackdriver.93e1480b.svg";
export { ForwardRef as ReactComponent };